import { TableCell, Button } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { Input, InputLabel, StyledTableRow } from "components/DSC";
import PropTypes from "prop-types";
import React,{useState} from "react";
import { useTranslation } from "react-i18next";
import { days } from "./constants";
import { useRowStyles } from "./styles";
import { formulas, isDayToggleOff } from "./utils";
import TextField from '@material-ui/core/TextField';
import { Add } from "@material-ui/icons";
import RemoveIcon from '@material-ui/icons/Remove';
import { useFieldArray, useWatch } from 'react-hook-form';
import Checkbox from '@material-ui/core/Checkbox';

const ManualActivityRow = (props) => {
  const { activity, register, setValue, onUpdate, productHours, getValues, errors, control, dscActivityEnable } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name: "customActData"
  });
  const customActData = useWatch({ control, name: "customActData", defaultValue: null });
  const classes = useRowStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const [selectedRows, setSelectedRows] = useState([]);

  const values = getValues();
  const daysData = values?.daysData;

  console.log("validate", errors);

  const handleRemove = async () =>{
    console.log("e, index", selectedRows)
    if(selectedRows && selectedRows.length>0 ){
    remove(selectedRows);
      onUpdate();
      setSelectedRows([]);
    }
  }

  const handleSelect = (e, index) => {
    console.log("e, index", e.target.checked, index);
    if(e.target.checked){
      setSelectedRows([...selectedRows, index]);
    }else{
      //let [index, ...rest] = selectedRows;
      let filteredRows = selectedRows.filter(val => val !== index)
      console.log("e, index", filteredRows);
      setSelectedRows(filteredRows);
    }
  }

  return (
    <React.Fragment>
      {fields.map((field, index) => (
      <StyledTableRow className={classes.root} key={field.id}>
        <TableCell
          className={classes.thRow}
          component="th"
          scope="row"
          style={{ fontWeight: "bold", fontSize: "12px", padding:'5px 14px 5px 16px'}}
        >
          <Checkbox
            color="primary"
            disabled={dscActivityEnable}
            inputProps={{ 'aria-label': 'primary checkbox' }}
            className={classes.checkbox}
            onChange={(e) => handleSelect(e, index)}
          />
         <TextField
            fullWidth
            margin="dense"
            name={`customActData[${index}].activityName`}
            value= { customActData?.[index]?.activityName}
            className={classes.textField}
            inputRef={register({ validate: (value) =>{
              const customActData = getValues().customActData;
              const currActData = customActData && customActData.length>0 && customActData[index];
              const currActDayPlan = currActData && currActData.dayPlan;
              let validate = true;
              currActDayPlan && Object.keys(currActDayPlan).forEach(day =>{
                  if(Object.values(currActDayPlan[day]).filter(val => !!Number(val)).length >0 || currActData.activityTarget !=""){
                    if(!value || value == ""){
                      validate = false;
                    }
                  }
              })
             return validate;
            }})}
            inputProps={{
              style: { fontWeight: "bold", fontSize: "12px", textTransform: "uppercase"},
            }}
            onChange={(e)=>{
              e.persist();
              onUpdate();
            }}
            rowsMax={4}
            variant="outlined"
            multiline
            error={!!errors?.['customActData']?.[index]?.['activityName']}
          />
        </TableCell>
        <TableCell
          align="right"
          style={{ paddingLeft: "0px", paddingRight: "4px" }}
        >
          <Input
            fullWidth
            margin="dense"
            type="number"
            name={`customActData[${index}].activityTarget`}
            value = {customActData?.[index]?.activityTarget}
            className={classes.capacity}
            inputProps={{
                  min: 0,
             }}
             error={!!errors?.['customActData']?.[index]?.['activityTarget']}
            inputRef={register({ validate: (value) =>{
              const customActData = getValues().customActData;
              const currActData = customActData && customActData.length>0 && customActData[index];
              const currActDayPlan = currActData && currActData.dayPlan;
              let validate = true;
              currActDayPlan && Object.keys(currActDayPlan).forEach(day =>{
                  if(Object.values(currActDayPlan[day]).filter(val => !!Number(val)).length >0 || currActData.activityName !=""){
                    if(!Number(value) || value == ""){
                      validate = false;
                    }
                  }
              })
             return validate;
            }})}
            onKeyDown={(evt) =>
              ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
            }
            onChange={(e) =>{
              e.persist();
              const value = e.target.value;
              const dayPlan = getValues().customActData[index].dayPlan ? getValues().customActData[index].dayPlan:{};
              Object.keys(dayPlan).forEach(plan => {
                const activityCount = parseInt(dayPlan[plan].activityCount ? dayPlan[plan].activityCount : "0");
                console.log("manualActCount", activityCount);
                if(activityCount){              
                  const targetCapacity = value;
                  const hours = targetCapacity ? formulas.getHours(targetCapacity, activityCount):'';
                  const staff = targetCapacity ? formulas.getStaff(targetCapacity, activityCount, productHours):'';
                  console.log("manual",plan, targetCapacity, hours, staff);
                  setValue(
                    `customActData[${index}].dayPlan.${plan}.hours`,
                    activityCount && Number(value) ? hours : ""
                  );
                  setValue(
                    `customActData[${index}].dayPlan.${plan}.staff`,
                    activityCount && Number(value) ? staff : ""
                  );
                }
              })
              onUpdate();
            }}
            // inputProps={{
            //   style: { backgroundColor: "#c8c6c8" },
            // }}
          />
        </TableCell>
        <TableCell style={{ paddingLeft: "4px", paddingRight: "0px" }}>
          <Input
            fullWidth
            margin="dense"
            type="number"
            name={`customActData[${index}].activityAverage`}
            value = {customActData?.[index]?.activityAverage}
            className={classes.average}
            inputRef={register()}
            // inputProps={{
            //   style: { backgroundColor: "#c8c6c8" },
            // }}
          />
        </TableCell>
        {days.map((cell, i) => (
          <React.Fragment key={cell}>
            <TableCell
              align="right"
              padding="none"
              style={{
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(1),
              }}
            >
              <Input
                type="number"
                disabled={isDayToggleOff(daysData, `day${i + 1}`) || dscActivityEnable}
                name={`customActData[${index}].dayPlan.day${i + 1}.activityCount`}
                value = {customActData?.[index]?.dayPlan?.[`day${i + 1}`]?.activityCount}
                inputRef={register()}
                onKeyDown={(evt) =>
                  ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
                }
                fullWidth
                margin="dense"
                defaultValue={""}
                className={classes.countField}
                inputProps={{
                  min: 0,
                }}
                onChange={(e) => {
                  e.persist();
                  const value = parseInt(e.target.value ? e.target.value : "0");
                  const targetCapacity = getValues().customActData[index].activityTarget;
                  const hours = targetCapacity ? formulas.getHours(targetCapacity, value):'';
                  const staff = targetCapacity ? formulas.getStaff(targetCapacity, value, productHours):'';
                  setValue(
                    `customActData[${index}].dayPlan.day${i + 1}.hours`,
                    value ? hours : ""
                  );
                  setValue(
                    `customActData[${index}].dayPlan.day${i + 1}.staff`,
                    value ? staff : ""
                  );
                  onUpdate();
                }}
                // onBlur={() => onUpdate()}
              />
            </TableCell>
            <TableCell align="left" padding="none">
              <InputLabel
                fullWidth
                readOnly
                margin="dense"
                disabled={isDayToggleOff(daysData, `day${i + 1}`) || dscActivityEnable}
                inputRef={register()}
                name={`customActData[${index}].dayPlan.day${i + 1}.hours`}
                value = {customActData?.[index]?.dayPlan?.[`day${i + 1}`]?.hours}
                className={classes.hrsField}
                inputProps={{ style: { backgroundColor: "#c7c6c7" } }}
              />
            </TableCell>
            <TableCell
              align="left"
              padding="none"
              style={{ paddingRight: theme.spacing(1) }}
            >
              <InputLabel
                fullWidth
                readOnly
                margin="dense"
                disabled={isDayToggleOff(daysData, `day${i + 1}`) || dscActivityEnable}
                inputRef={register()}
                name={`customActData[${index}].dayPlan.day${i + 1}.staff`}
                value={customActData?.[index]?.dayPlan?.[`day${i + 1}`].staff}
                className={classes.staffField}
                inputProps={{ style: { backgroundColor: "#c7c6c7" } }}
              />
            </TableCell>
          </React.Fragment>
        ))}
          <React.Fragment key="total">
            <TableCell
              align="right"
              padding="none"
              style={{
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(1),
              }}
            >
              <Input
                type="number"
                readOnly
                name={`customActData[${index}].dayPlan.weekTotal.activityCount`}
                value={customActData?.[index]?.dayPlan?.weekTotal?.activityCount}
                inputRef={register()}
                fullWidth
                margin="dense"
                className={classes.countField}
                inputProps={{
                  min: 0,
                  style: { backgroundColor: "#c7c6c7" }
                }}
                defaultValue='0'
              />
            </TableCell>
            <TableCell align="left" padding="none">
              <InputLabel
                fullWidth
                readOnly
                margin="dense"
                inputRef={register()}
                name={`customActData[${index}].dayPlan.weekTotal.hours`}
                value={customActData?.[index]?.dayPlan?.weekTotal?.hours}
                className={classes.hrsField}
                inputProps={{ style: { backgroundColor: "#c7c6c7" } }}
                defaultValue='0.0'
              />
            </TableCell>
            <TableCell
              align="left"
              padding="none"
              style={{ paddingRight: theme.spacing(1) }}
            >
              <InputLabel
                fullWidth
                readOnly
                margin="dense"
                inputRef={register()}
                name={`customActData[${index}].dayPlan.weekTotal.staff`}
                value={customActData?.[index]?.dayPlan?.weekTotal?.staff}
                className={classes.staffField}
                inputProps={{ style: { backgroundColor: "#c7c6c7" } }}
                defaultValue='0.0'
              />
            </TableCell>
          </React.Fragment>
      </StyledTableRow>
        ))}
         <StyledTableRow className={classes.root}>
          <TableCell  style={{backgroundColor:"#FFFFFF", position:'sticky', left:0}} colSpan={10}>
            <div style={{display:'flex', columnGap:'10px'}}>
                    <Button  onClick={()=>{append({})}} color="primary" disabled = {dscActivityEnable}>
                      <Add /> {t("other.timeSheetAdd")}
                    </Button>

                    <Button 
                    style={{paddingLeft:'20px', display:'flex', alignItems:'initial',
                     color:selectedRows.length>0?'red':'inherit', opacity:selectedRows.length>0?1:0.2}} 
                    color="error"
                    onClick={handleRemove} disabled={!selectedRows.length>0 || dscActivityEnable}>
                      <RemoveIcon /> {t("other.tblDel")}
                    </Button>
                    </div>
            </TableCell>
             </StyledTableRow>
    </React.Fragment>
  );
};
ManualActivityRow.propTypes = {
  activity: PropTypes.any,
  register: PropTypes.any,
  control: PropTypes.any,
  setValue: PropTypes.any,
  activityId: PropTypes.any,
  onUpdate: PropTypes.func,
  averageBy: PropTypes.any,
};
export default ManualActivityRow;
